<template>
  <div class="renewPrice">
    <div class="renewPrice__header">
      卡号：<el-input 
        size="small"
        type="text"
        style="width:200px;margin-right:10px;"
        v-model="params.sim"
      />
      套餐类型：
      <el-select
        v-model="params.simType"
        placeholder="请选择"
        size="small"
        style="width:165px;margin:0 20px 0 0"
      >
        <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        type="date"
        placeholder="开始时间"
        v-model="params.startTime"
      >
      </el-date-picker>
      <span class="split-line"></span>
      <el-date-picker
        type="date"
        placeholder="结束时间"
        v-model="params.endTime"
      >
      </el-date-picker>
      <el-button
        type="primary"
        size="small"
        style="margin-left:10px;"
        @click="getData"
      >查询</el-button>
    </div>
    <div class="renewPrice__content">
      <div class="filter-table-wrap">
        <el-table
          :data="tableData"
          style="width: 100%"
          size="mini"
          border
          height="calc(100% - 90px)">
          <el-table-column
            type="index"
            width="50"
            label="序号"
          />
          <el-table-column
            prop="simCard"
            align="center"
            label="SIM"
            width="150"
          />
          <el-table-column
            prop="iccId"
            align="center"
            label="ICCDI"
          />
          <el-table-column
            width="100"
            prop="sn"
            align="center"
            label="SN"
          />
          <el-table-column
            width="100"
            prop="price"
            align="center"
            label="支付金额"
          />
          <el-table-column
            width="180"
            prop="renewTime"
            align="center"
            label="续费时间"
          />
          <el-table-column
            width="150"
            prop="years"
            align="center"
            label="续费年限"
          />
          <el-table-column
            width="200"
            prop="expireTime"
            align="center"
            label="到期时间"
          />
          <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
          />
        </el-table>
        <el-pagination
          :current-page.sync="params.pageNumber"
          :page-sizes="[100, 200, 300, 400]"
          :page-size.sync="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      tableData:[],
      params:{
        sim:"",
        simType:'',
        pageNumber:1,
        pageSize:100,
        startTime:new Date().Format('yyyy-MM-01'),
        endTime:new Date().Format('yyyy-MM-dd'),
      },
      total:0,
      typeList:[
        {
          value:'30M',
          lable:0
        },
        {
          value:'100M',
          lable:1
        },
      ]
    }
  },
  created(){
    this.getData();
  },
  methods:{
    //查询数据
    async getData(){
      let { simType,...params } = this.params;
      const { data } = await this.$API.getUserRenewalRecordBySim({
        ...params,
        simType:parseInt(simType)
      });
      this.tableData = data.data;
    }
  }
}
</script>
<style lang="scss" scoped>
.renewPrice{
  width: 100%;
  height:100%;
  padding: 10px 0;
  box-sizing: border-box;
  &__header {
    width: 100%;
    display: flex;
    padding: 10px 20px;
    background: #ffffff;
    height: 84px;
    align-items: center;
    font-size: 14px;
    box-sizing: border-box;
    .filter-type-input {
      background: #edf2f8;
      color: #828588;
      border: none;
      outline: 0;
      padding: 0 15px;
      height: 30px;
    }
    /deep/ .el-date-editor {
      width: 15%;
      .el-input__inner {
        padding-left: 30px;
        height: 30px;
        border-radius: 0;
        outline: none;
        border: 0;
        background: #f3f7fb;
      }
      .el-input__icon {
        line-height: 30px;
      }
    }
  }
  &__content {
    flex: 1;
    background: #fff;
    height: calc(100% - 84px);
    padding-top: 10px;
    padding:0 10px;
    .filter-table-wrap {
      border: 1px solid #ebf0f6;
      height: 100%;
      /deep/ .el-pagination {
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        & > span {
          margin: 0;
        }
        .el-pagination__total {
          margin-right: auto;
        }
      }
    }
  }
}
</style>